<div
  class="legal-page"
  [class.client-source]="isClientSource()"
  [class.veterinarian]="isVetSource()"
  [class.dark]="theme() === 'dark'"
  [class.light]="theme() === 'light'"
>
  <!-- Header -->
  <header class="legal-header">
    <div class="header-inner">
      <div class="logo-mark"></div>
      <span class="header-title">Anihis</span>
    </div>
  </header>

  <!-- Content -->
  <main class="legal-content">
    <div class="legal-container">
      <h1 class="page-title">{{ 'legal.pp.title' | transloco }}</h1>
      <p class="last-updated">{{ 'legal.pp.effectiveDate' | transloco }}</p>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s1.h' | transloco }}</h2>
        @if (isClientAppOnly()) {
          <p>{{ 'legal.pp.s1.p1_client' | transloco }}</p>
        } @else {
          <p>{{ 'legal.pp.s1.p1' | transloco }}</p>
        }
        <p>{{ 'legal.pp.s1.p2' | transloco }}</p>
        <p>{{ 'legal.pp.s1.p3' | transloco }}</p>
      </section>

      @if (isClientAppOnly()) {
        <section class="legal-section">
          <h2>{{ 'legal.pp.vetDisclaimer.h' | transloco }}</h2>
          <p>{{ 'legal.pp.vetDisclaimer.p1' | transloco }}</p>
        </section>
      }

      <section class="legal-section">
        <h2>{{ 'legal.pp.s2.h' | transloco }}</h2>
        <p>
          <strong>{{ 'legal.pp.s2.directLabel' | transloco }}</strong>
        </p>
        <ul>
          <li>{{ 'legal.pp.s2.i_account' | transloco }}</li>
          @if (isClientAppOnly()) {
            <li>{{ 'legal.pp.s2.i_profile_client' | transloco }}</li>
          } @else {
            <li>{{ 'legal.pp.s2.i_profile' | transloco }}</li>
          }
          @if (isClientAppOnly()) {
            <li>{{ 'legal.pp.s2.i_pet_profile_client' | transloco }}</li>
            <li>{{ 'legal.pp.s2.i_vet_records_client' | transloco }}</li>
            <li>{{ 'legal.pp.s2.i_documents_client' | transloco }}</li>
            <li>{{ 'legal.pp.s2.i_reminders_client' | transloco }}</li>
          } @else {
            <li>{{ 'legal.pp.s2.i_animal' | transloco }}</li>
            <li>{{ 'legal.pp.s2.i_clinic' | transloco }}</li>
          }
          <li>{{ 'legal.pp.s2.i_comms' | transloco }}</li>
        </ul>
        <p>
          <strong>{{ 'legal.pp.s2.autoLabel' | transloco }}</strong>
        </p>
        <ul>
          <li>{{ 'legal.pp.s2.i_device' | transloco }}</li>
          <li>{{ 'legal.pp.s2.i_usage' | transloco }}</li>
          <li>{{ 'legal.pp.s2.i_log' | transloco }}</li>
          @if (isClientAppOnly()) {
            <li>{{ 'legal.pp.s2.i_location_client' | transloco }}</li>
          } @else {
            <li>{{ 'legal.pp.s2.i_location' | transloco }}</li>
          }
          <li>{{ 'legal.pp.s2.i_cookies' | transloco }}</li>
        </ul>
        <p>
          <strong>{{ 'legal.pp.s2.specialLabel' | transloco }}</strong>
        </p>
        @if (isClientAppOnly()) {
          <p>{{ 'legal.pp.s2.specialP_client' | transloco }}</p>
        } @else {
          <p>{{ 'legal.pp.s2.specialP' | transloco }}</p>
        }
      </section>

      @if (isClientAppOnly()) {
        <section class="legal-section">
          <h2>{{ 'legal.pp.location.h' | transloco }}</h2>
          <p>{{ 'legal.pp.location.p1' | transloco }}</p>
          <p>
            <strong>{{ 'legal.pp.location.why_h' | transloco }}</strong>
          </p>
          <ul>
            <li>{{ 'legal.pp.location.i_nearby' | transloco }}</li>
            <li>{{ 'legal.pp.location.i_registration' | transloco }}</li>
            <li>{{ 'legal.pp.location.i_listings' | transloco }}</li>
            <li>{{ 'legal.pp.location.i_reverse' | transloco }}</li>
          </ul>
          <p>
            <strong>{{ 'legal.pp.location.optional_h' | transloco }}</strong>
          </p>
          <p>{{ 'legal.pp.location.optional_p' | transloco }}</p>
          <p>
            <strong>{{ 'legal.pp.location.processing_h' | transloco }}</strong>
          </p>
          <p>{{ 'legal.pp.location.processing_p' | transloco }}</p>
          <p>
            <strong>{{ 'legal.pp.location.thirdParty_h' | transloco }}</strong>
          </p>
          <p>{{ 'legal.pp.location.thirdParty_p' | transloco }}</p>
        </section>
      }

      <section class="legal-section">
        <h2>{{ 'legal.pp.s3.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s3.intro' | transloco }}</p>
        <ul>
          <li>
            <strong>{{ 'legal.pp.s3.contract_h' | transloco }}</strong>
            @if (isClientAppOnly()) {
              {{ 'legal.pp.s3.contract_p_client' | transloco }}
            } @else {
              {{ 'legal.pp.s3.contract_p' | transloco }}
            }
          </li>
          <li>
            <strong>{{ 'legal.pp.s3.legal_h' | transloco }}</strong>
            {{ 'legal.pp.s3.legal_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s3.legit_h' | transloco }}</strong>
            {{ 'legal.pp.s3.legit_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s3.consent_h' | transloco }}</strong>
            {{ 'legal.pp.s3.consent_p' | transloco }}
          </li>
          <li>
            @if (isClientAppOnly()) {
              <strong>{{ 'legal.pp.s3.health_h_client' | transloco }}</strong>
              {{ 'legal.pp.s3.health_p_client' | transloco }}
            } @else {
              <strong>{{ 'legal.pp.s3.health_h' | transloco }}</strong>
              {{ 'legal.pp.s3.health_p' | transloco }}
            }
          </li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s4.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s4.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.pp.s4.i1' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i3' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i4' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i5' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i6' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i7' | transloco }}</li>
          <li>{{ 'legal.pp.s4.i8' | transloco }}</li>
          @if (isClientAppOnly()) {
            <li>{{ 'legal.pp.s4.i9_client' | transloco }}</li>
            <li>{{ 'legal.pp.s4.i10_client' | transloco }}</li>
          } @else {
            <li>{{ 'legal.pp.s4.i9' | transloco }}</li>
          }
        </ul>
      </section>

      <section class="legal-section">
        @if (isClientAppOnly()) {
          <h2>{{ 'legal.pp.s5.h_client' | transloco }}</h2>
        } @else {
          <h2>{{ 'legal.pp.s5.h' | transloco }}</h2>
        }
        <p>
          <strong>{{ 'legal.pp.s5.important' | transloco }}</strong>
        </p>
        @if (isClientAppOnly()) {
          <p>{{ 'legal.pp.s5.p1_client' | transloco }}</p>
        } @else {
          <p>{{ 'legal.pp.s5.p1' | transloco }}</p>
        }
        <ul>
          @if (isClientAppOnly()) {
            <li>{{ 'legal.pp.s5.i1_client' | transloco }}</li>
            <li>{{ 'legal.pp.s5.i2_client' | transloco }}</li>
          } @else {
            <li [innerHTML]="'legal.pp.s5.i1' | transloco"></li>
            <li>{{ 'legal.pp.s5.i2' | transloco }}</li>
          }
          <li>{{ 'legal.pp.s5.i3' | transloco }}</li>
          @if (!isClientAppOnly()) {
            <li>{{ 'legal.pp.s5.i4' | transloco }}</li>
          }
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s6.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s6.intro' | transloco }}</p>
        <ul>
          <li>
            <strong>{{ 'legal.pp.s6.account_h' | transloco }}</strong>
            {{ 'legal.pp.s6.account_p' | transloco }}
          </li>
          <li [innerHTML]="'legal.pp.s6.health' | transloco"></li>
          <li>
            <strong>{{ 'legal.pp.s6.log_h' | transloco }}</strong>
            {{ 'legal.pp.s6.log_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s6.marketing_h' | transloco }}</strong>
            {{ 'legal.pp.s6.marketing_p' | transloco }}
          </li>
        </ul>
        <p>{{ 'legal.pp.s6.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s7.h' | transloco }}</h2>
        @if (isClientAppOnly()) {
          <p>{{ 'legal.pp.s7.p1_client' | transloco }}</p>
        } @else {
          <p>{{ 'legal.pp.s7.p1' | transloco }}</p>
        }
        <ul>
          <li>{{ 'legal.pp.s7.i1' | transloco }}</li>
          <li>{{ 'legal.pp.s7.i2' | transloco }}</li>
          <li>{{ 'legal.pp.s7.i3' | transloco }}</li>
          <li>{{ 'legal.pp.s7.i4' | transloco }}</li>
          <li>{{ 'legal.pp.s7.i5' | transloco }}</li>
          <li>{{ 'legal.pp.s7.i6' | transloco }}</li>
        </ul>
        <p>{{ 'legal.pp.s7.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s8.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s8.intro' | transloco }}</p>
        <ul>
          <li>
            <strong>{{ 'legal.pp.s8.processors_h' | transloco }}</strong>
            @if (isClientAppOnly()) {
              {{ 'legal.pp.s8.processors_p_client' | transloco }}
            } @else {
              {{ 'legal.pp.s8.processors_p' | transloco }}
            }
          </li>
          <li>
            <strong>{{ 'legal.pp.s8.vets_h' | transloco }}</strong>
            {{ 'legal.pp.s8.vets_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s8.authorities_h' | transloco }}</strong>
            {{ 'legal.pp.s8.authorities_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s8.transfer_h' | transloco }}</strong>
            {{ 'legal.pp.s8.transfer_p' | transloco }}
          </li>
        </ul>
        <p>{{ 'legal.pp.s8.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s9.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s9.p1' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s10.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s10.p1' | transloco }}</p>
        <ul>
          <li>{{ 'legal.pp.s10.i1' | transloco }}</li>
          <li>{{ 'legal.pp.s10.i2' | transloco }}</li>
          <li>{{ 'legal.pp.s10.i3' | transloco }}</li>
        </ul>
        <p>{{ 'legal.pp.s10.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s11.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s11.intro' | transloco }}</p>
        <ul>
          <li>
            <strong>{{ 'legal.pp.s11.access_h' | transloco }}</strong>
            {{ 'legal.pp.s11.access_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s11.rect_h' | transloco }}</strong>
            {{ 'legal.pp.s11.rect_p' | transloco }}
          </li>
          @if (isClientAppOnly()) {
            <li [innerHTML]="'legal.pp.s11.erasure_client' | transloco"></li>
          } @else {
            <li [innerHTML]="'legal.pp.s11.erasure' | transloco"></li>
          }
          <li>
            <strong>{{ 'legal.pp.s11.restrict_h' | transloco }}</strong>
            {{ 'legal.pp.s11.restrict_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s11.portability_h' | transloco }}</strong>
            {{ 'legal.pp.s11.portability_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s11.object_h' | transloco }}</strong>
            {{ 'legal.pp.s11.object_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s11.withdrawConsent_h' | transloco }}</strong>
            {{ 'legal.pp.s11.withdrawConsent_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s11.automated_h' | transloco }}</strong>
            {{ 'legal.pp.s11.automated_p' | transloco }}
          </li>
        </ul>
        <p>{{ 'legal.pp.s11.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s12.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s12.p1' | transloco }}</p>
        <p>{{ 'legal.pp.s12.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s13.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s13.p1' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s14.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s14.p1' | transloco }}</p>
        <ul>
          <li>
            <strong>{{ 'legal.pp.s14.necessary_h' | transloco }}</strong>
            {{ 'legal.pp.s14.necessary_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s14.functional_h' | transloco }}</strong>
            {{ 'legal.pp.s14.functional_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.pp.s14.analytics_h' | transloco }}</strong>
            {{ 'legal.pp.s14.analytics_p' | transloco }}
          </li>
        </ul>
        <p>{{ 'legal.pp.s14.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s15.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s15.p1' | transloco }}</p>
        <ul>
          <li>
            {{ 'legal.pp.s15.emailLabel' | transloco }}:
            <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
          </li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s16.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s16.p1' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.pp.s17.h' | transloco }}</h2>
        <p>{{ 'legal.pp.s17.p1' | transloco }}</p>
        <ul>
          <li>
            {{ 'legal.pp.s17.companyLabel' | transloco }}:
            <strong>Anihis doo</strong>
          </li>
          <li>{{ 'legal.pp.s17.regLabel' | transloco }}: 22211382</li>
          <li>{{ 'legal.pp.s17.taxLabel' | transloco }}: 115770230</li>
          <li>
            {{ 'legal.pp.s17.addressLabel' | transloco }}: Omladinska 50, 18360
            Svrljig, Republic of Serbia
          </li>
          <li>
            {{ 'legal.pp.s17.emailLabel' | transloco }}:
            <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
          </li>
          <li>{{ 'legal.pp.s17.inApp' | transloco }}</li>
        </ul>
      </section>
    </div>
  </main>
</div>
